import TipsAndTricksCard from './card/Card';
import RelatedTips from './relatedTips/RelatedTips';
export { RelatedTips, TipsAndTricksCard };